import React, { useEffect, useState } from "react";

function NotificationPopUp({ title, message }: { title: string; message: string }) {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const start = Date.now();
    const duration = 5000; 

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const percent = Math.max(0, 100 - (elapsed / duration) * 100);
      setProgress(percent);

      if (elapsed >= duration) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="notificationContainer">
      <div>{title}</div>
      <div className="notificationText">{message}</div>
      <div
        className="progressBar"
        style={{
          height: "4px",
          backgroundColor: "#4caf50",
          width: `${progress}%`,
          transition: "width 0.1s linear",
          marginTop: "8px",
        }}
      ></div>
    </div>
  );
}

export default NotificationPopUp;
